import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import Routes from './routes';
import history from './services/history';
 

export default class App extends Component {
  render() {
    return (
      <Router history={history}>
        <Routes/>
      </Router>
    );
  }
}
